import call, { json } from './call';

// The AI model catalog endpoints (CONTEXT.md "AI Models"). Admin only.
const BASE = '/api/admin/ai';

// { models: [...catalog rows], tasks: [{task, label, ai_model_id}] }
export const fetchAiModels = (token) => call(`${BASE}/models`, token, { method: 'GET' });
// { added: [...], unlisted: [...], skipped: [...providers without a key] }
export const refreshAiModels = (token) => call(`${BASE}/models/refresh`, token, { method: 'POST' });
export const addAiModel = (token, payload) => call(`${BASE}/models`, token, json('POST', payload));
export const updateAiModel = (token, id, patch) => call(`${BASE}/models/${id}`, token, json('PATCH', patch));
export const assignAiTask = (token, task, aiModelId) => call(
    `${BASE}/tasks/${task}`, token, json('PUT', { ai_model_id: aiModelId }),
);
